import AuthScene from "./AuthScene";
import "./auth-fields.css";
import "./AuthLayout.css";

const AUTH_BG_VERSION = "7";
const AUTH_PAGE_BG = `${process.env.PUBLIC_URL || ""}/assets/images/auth-aside-decor.png?v=${AUTH_BG_VERSION}`;

function AuthLayout({ children }) {
  return (
    <div className="auth-layout auth-fields-scope">
      <div className="auth-layout__bg" aria-hidden="true">
        <img
          src={AUTH_PAGE_BG}
          alt=""
          className="auth-layout__bg-img"
          loading="eager"
          decoding="async"
        />
        <div className="auth-layout__bg-overlay" />
      </div>
      <AuthScene />
      <div className="auth-layout__stage">
        <div className="auth-split auth-split--polished" role="main">
          <div className="auth-split__main">
            <div className="auth-split__main-inner">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
